export const translationLivechat_da_availability = {
  livechatChangeAvailability: "Tilgængelighed:",
  livechatGoOnline: "Gå online",
  livechatGoOffline: "Gå offline",
  livechatUseSchedule: "Brug åbningstider",
  livechatAvailabilityDisabledHelp: "Chatbots deaktiveret af en administrator ændres ikke.",
  livechatAvailabilityUpdated: "Tilgængelighed opdateret for {count} chatbots i {scope}.",
  livechatAvailabilityUpdatedOne: "Tilgængelighed opdateret for {chatbot}.",
  livechatAvailabilityAllOnline: "Alle online",
  livechatAvailabilityAllOffline: "Alle offline",
  livechatAvailabilityMixed: "Blandet · {online} af {total} online",
  livechatAvailabilityUnknown: "Tilgængelighed kunne ikke hentes",
};
